<template>
	<div class="titBox">
		<template v-for="(item,index) in submenu">
			<el-button @click="to_page(item)" :type="nav == index ? 'primary' : ''">{{ item.btn_name }}</el-button>
		</template>
		<!-- <p class="tit">
			我的考试
			<el-tooltip class="item" effect="dark" content="点击切换到学业水平综合培训考试" placement="right">
				<i class="iconfont swPage">&#xe68c;</i>
			</el-tooltip>
		</p> -->
		<div class="titRightBox">
			<el-button type="primary" @click="refresh">刷新</el-button>
			<!-- <ul class="qi" :class="$store.state.qiFocus" @click="qiClick($event)">
				<i class="iconfont">&#xe610;</i>
				<li v-for="(index,i) of qiCount" :key="i" @click.stop="qiClick($event,index)" :class="qiNum==index?'act':''">第{{qiZh(index)}}学期{{qiDang==index?"（当前学期）":""}}</li>
			</ul> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'menu'
	,props:["nav"]
	,data () {
		return {
			submenu:[{
				path: '/web/exam_list',
				name: 'exam_list',
				query: {page: 'exam_list'},
				btn_name: '成考考试',
			},{
				path: '/web/exam_list_en',
				name: 'exam_list_en',
				query: {page: 'exam_list_en'},
				params: '',
				btn_name: '准考证下载',
			},{
				path: '/web/exam_sign_up',
				name: 'exam_sign_up',
				query: {page: 'exam_sign_up'},
				params: '',
				btn_name: '报名入口',
			}]
		}
	}
	,mounted:function(){	
	}
	,watch:{
	}
	,methods:{
		// 刷新事件
		refresh(){
			this.$emit("refresh")
		},
		to_page(item){
			this.$router.push(item)	
		},
	},
	computed:{
	},
}
</script>


// WEBPACK FOOTER //
// src/components/course_info/submenu.vue